import { useMemo } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useEducationStore } from "../../../_store/educationStore";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";
import {
  findDebtCreditcard,
  findDebtInformalShortterm,
  findDebtShortterm,
  findDebtShorttermOther,
  findLongDebtCar,
  findLongDebtOther,
  findLongDebtPlace,
} from "../../../functions/futurePlan/futurechartFunction";
import { cn } from "../../../utils/useFunctions";
import { ChartCashFlow } from "../../future_plan/components/VIChartCashFlow.Main";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import {
  STYLE_PAGE_HORIZONTAL,
  STYLE_PDF_TEXT_MEDIUM_BLUE_12,
} from "../styles/pdf.style";
import numeral from "numeral";

function ResultChartFuturePdf({ page }) {
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const educationData = useEducationStore((state) => state.educationData);

  const merge_keys = useMemo(() => {
    let income_keys = futurePlanData?.cash_flow_keys?.filter(
      (cash_flow_key) => {
        return cash_flow_key.includes("income");
      }
    );
    let expenese_keys = futurePlanData?.cash_flow_keys?.filter(
      (cash_flow_key) => {
        return cash_flow_key.includes("expenese");
      }
    );
    let merge_income_keys = [
      // ...income_keys,
      "other_income",
      "income_peryear",
      "remain_accumulate",
      "pension_peryear",
      "income_investment",
    ];
    let merge_expenese_keys = [
      // ...expenese_keys,
      "outcome_peryear",
      "out_come_stable",
    ];

    let merge_keys = [...merge_expenese_keys, ...merge_income_keys];
    // merge_keys = [];

    // หนี้ดอกลอย
    let debtShortList = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_shortterm_other"
    )?.short_term_others;

    if (debtShortList?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findDebtShorttermOther(balanceData, futurePlanData).title,
      ];
    }

    // หนี้ีนอกระบบ
    let debtInformalShortterm = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_informal_shortterm"
    )?.informal_short_terms;

    if (debtInformalShortterm?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findDebtInformalShortterm(balanceData, futurePlanData).title,
      ];
    }

    // เงินกู้ระยะสั้น
    let debtShorShortList = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_shortterm"
    )?.short_terms;

    if (debtShorShortList?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findDebtShortterm(balanceData, futurePlanData).title,
      ];
    }

    // บัตรเครดิต
    let debtCreditcard = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_creditcard"
    )?.credit_cards;

    if (debtCreditcard?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findDebtCreditcard(balanceData, futurePlanData).title,
      ];
    }

    // หนี้ระยะยาว รถ
    let debtCar = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_car"
    )?.debt_long_cars;

    if (debtCar?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findLongDebtCar(balanceData, futurePlanData).title,
      ];
    }

    // หนี้ระยะยาว บ้าน
    let DebtPlace = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_car"
    )?.debt_long_cars;

    if (DebtPlace?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findLongDebtPlace(balanceData, futurePlanData).title,
      ];
    }

    // หนี้ระยะยาว อื่นๆ
    let DebtOther = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_long_other"
    )?.debt_long_others;

    if (DebtOther?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findLongDebtOther(balanceData, futurePlanData).title,
      ];
    }

    return merge_keys;
  }, [futurePlanData]);

  const dataDebt = useMemo(() => {
    let dataDebt = [];

    for (const merge_key of merge_keys) {
      let dataDebtItems = [];
      for (const cash_flow_item of futurePlanData.cash_flow_items) {
        if (cash_flow_item[merge_key] !== undefined) {
          let amount = String(merge_key).startsWith("expenese")
            ? -cash_flow_item[merge_key]
            : cash_flow_item[merge_key];

          amount = Math.round(amount);
          if ([0, -0].includes(amount)) {
            amount = "";
          }

          dataDebtItems.push(amount);
        }
      }

      dataDebt.push(dataDebtItems);
    }

    dataDebt = dataDebt.filter((item) => item.length !== 0);

    // หนี้ดอกลอย
    let debtShortList = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_shortterm_other"
    )?.short_term_others;

    if (debtShortList?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findDebtShorttermOther(balanceData, futurePlanData).value,
      ];
    }

    // หนี้ีนอกระบบ
    let debtInformalShortterm = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_informal_shortterm"
    )?.informal_short_terms;

    if (debtInformalShortterm?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findDebtInformalShortterm(balanceData, futurePlanData).value,
      ];
    }

    // เงินกู้ระยะสั้น
    let debtShorShortList = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_shortterm"
    )?.short_terms;

    if (debtShorShortList?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findDebtShortterm(balanceData, futurePlanData).value,
      ];
    }

    // บัตรเครดิต
    let debtCreditcard = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_creditcard"
    )?.credit_cards;

    if (debtCreditcard?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findDebtCreditcard(balanceData, futurePlanData).value,
      ];
    }

    // หนี้ระยะยาว รถ
    let debtCar = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_car"
    )?.debt_long_cars;

    if (debtCar?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findLongDebtCar(balanceData, futurePlanData).value,
      ];
    }

    // หนี้ระยะยาว บ้าน
    let DebtPlace = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_car"
    )?.debt_long_cars;

    if (DebtPlace?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findLongDebtPlace(balanceData, futurePlanData).value,
      ];
    }

    // หนี้ระยะยาว อื่นๆ
    let DebtOther = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_long_other"
    )?.debt_long_others;

    if (DebtOther?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findLongDebtOther(balanceData, futurePlanData).value,
      ];
    }

    return dataDebt;
  }, [futurePlanData]);

  const labels = useMemo(() => {
    let labels = [];
    for (const cash_flow_item of futurePlanData.cash_flow_items) {
      // if (cash_flow_item.age % 5 === 0) {
      //   labels.push(cash_flow_item.age);
      // }
      labels.push(cash_flow_item.age);
    }

    return labels;
  }, [futurePlanData]);

  const merge_keys_second = useMemo(() => {
    let merge_keys = [];

    // รายจ่ายบ้าน
    let expenseHome = futurePlanData?.expenese_home_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_expense" + "_home_expense";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายจ่ายรถ
    let expenseCar = futurePlanData?.expenese_car_items?.map((item, index) => {
      let textCombine = item?.title + "_Is_type_expense" + "_car_expense";
      merge_keys = [...merge_keys, textCombine];
      return;
    });

    // รายจ่ายลูก
    let expenseChild = futurePlanData?.expenese_children_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_expense" + "_child_expense";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายจ่ายการศึกษาลูก
    // console.log("educationData", educationData);
    if (futurePlanData?.expenese_children_education?.length > 0) {
      let expenseChildEducation = educationData?.map((item, index) => {
        let textCombine = item?.name + "_Is_type_expense" + "_child_Education";
        merge_keys = [...merge_keys, textCombine];
        return;
      });
    }

    // รายจ่ายท่องเที่ยว
    let expensetravel = futurePlanData?.expenese_travel_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_expense" + "_travel_expense";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายจ่ายสะสม
    let expensecollect = futurePlanData?.expenese_collection_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_expense" + "_collect_expense";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายจ่ายอื่นๆ
    let expenese_other_items = futurePlanData?.expenese_other_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_expense" + "_other_expense";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายรับมรดก
    let incomelegacy = futurePlanData?.income_legacy_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_income" + "_legacy_income";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายรับธุรกิจ
    let incomeBusiness = futurePlanData?.income_business_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_income" + "_business_income";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายรับอสังหาริมทรัพย์
    let incomeProperty = futurePlanData?.income_property_items?.map(
      (item, index) => {
        let textCombine = item?.title + "_Is_type_income" + "_property_income";
        merge_keys = [...merge_keys, textCombine];
        return;
      }
    );

    // รายรับอื่นๆ
    let incomeOther = futurePlanData?.income_other_items?.map((item, index) => {
      let textCombine = item?.title + "_Is_type_income" + "_Other_income";
      merge_keys = [...merge_keys, textCombine];
      return;
    });

    return merge_keys;
  }, [futurePlanData]);

  const colors = useMemo(() => {
    return merge_keys?.map((key) => {
      if (key === "income_peryear") {
        return { label: "รายรับต่อปี", color: "#47A3F7" };
      } else if (key === "other_income") {
        return { label: "รายรับอื่น ๆ", color: "#BDC333" };
      } else if (key === "remain_accumulate") {
        return { label: "ยอดเงินสะสม", color: "#00B61D" };
      } else if (key === "outcome_peryear") {
        return { label: "รายจ่ายต่อปี", color: "#F7A647" };
      } else if (key === "expenese_home_items") {
        return { label: "บ้าน", color: "#FFD12C" };
      } else if (key === "expenese_car_items") {
        return { label: "รถ", color: "#AF2CFF" };
      } else if (key === "expenese_children_items") {
        return { label: "ลูก", color: "#FF00FF" };
      } else if (key === "expenese_travel_items") {
        return { label: "ท่องเที่ยว", color: "#00FF00" };
      } else if (key === "expenese_collection_items") {
        return { label: "ของสะสม", color: "#FB3CBD" };
      } else if (key === "expenese_other_items") {
        return { label: "รายจ่ายอื่นๆ", color: "#BDC333" };
      } else if (key === "income_legacy_items") {
        return { label: "รายรับจากมรดก", color: "#FF0000" };
      } else if (key === "income_business_items") {
        return { label: "รายรับจากธุรกิจ", color: "#00FFFF" };
      } else if (key === "income_property_items") {
        return { label: "รายรับจากอสังหาริม", color: "#FFA500" };
      } else if (key === "income_other_items") {
        return { label: "รายรับอื่นๆ", color: "#0000FF" };
      }
    });
  }, [dataDebt]);

  const dynamicWidth = Math.max(labels.length * 80, 800);

  // console.log("labels",labels?.filter((item)=> item%5 === 0))
  // console.log("futurePlanData",futurePlanData)
  // console.log("educationData",educationData)
  // console.log("====================")

  return (
    <div className={cn(STYLE_PAGE_HORIZONTAL)}>
      {/* Cash Flow */}
      <PdfCard
        className={""}
        title={"กระแสเงินสดรายรับราย จ่ายของแผนอนาคต"}
        classNameTitle={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_12, { "h-full": true })}
      >
        <PdfCardWhite>
          <div className="w-full h-full  ">
            <ChartCashFlow
              part="report"
              isAverage={true}
              futurePlanData={futurePlanData}
              educationData={educationData}
              labels={labels}
              dataDebt={dataDebt}
              merge_keys={merge_keys}
              merge_keys_second={merge_keys_second}
              // width={dynamicWidth}
              isHasDataLabel={true}
              outSideStyle="overflow-visible w-full h-[300px]"
              width={750}
              height={300}
              barOptions={{
                barPercentage: 1,
                barthickness: 30,
              }}
              options={{
                devicePixelRatio: 5, // Increase resolution for retina/high-DPI screens
                responsive: true,
                interaction: {
                  intersect: true,
                },
                scales: {
                  x: {
                    stacked: true,
                    title: {
                      display: true,
                      text: "อายุ(ปี)", // Label for X-axis
                    },
                    ticks: {
                      autoSkip: true,
                      font: {
                        size: 8,
                      },
                      callback: function (value, index, values) {
                        return (value + futurePlanData?.age_current) % 5 === 0
                          ? value + futurePlanData?.age_current
                          : "";
                      },
                    },
                  },
                  y: {
                    stacked: true,
                    title: {
                      display: true,
                      text: "จำนวนเงิน(บาท)", // Label for X-axis
                    },
                    ticks: {
                      font: {
                        size: 8,
                      },
                      callback: function (value, index, values) {
                        return Math.abs(value) > 1000000
                          ? `${numeral(value / 1000000)?.format("0,0")}M`
                          : value > 10000
                          ? `${numeral(value / 10000)?.format("0,0")}k`
                          : value === 0
                          ? 0
                          : value < 1000
                          ? `${numeral(value)?.format("0,0")}`
                          : value;
                      },
                    },
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                    labels: {
                      boxWidth: 14,
                      boxHeight: 14,
                    },
                    position: "bottom",
                    align: "start",
                  },
                },
              }}
            />
          </div>
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default ResultChartFuturePdf;
